import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { SignedContractListStore } from "../../store/SignedContractListStore";

type SignedContractListDialogsProps = {
  store: SignedContractListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de SignedContract.
 * Separado para mantener SignedContractListPage más limpio.
 */
export const SignedContractListDialogs: React.FC<SignedContractListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
